var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8332 18C17.6742 18 19.1666 16.5076 19.1666 14.6667V7.18557C19.1669 7.17283 19.1669 7.16005 19.1666 7.14725V6.33333C19.1666 4.49238 17.6742 3 15.8332 3H4.16656C2.32561 3 0.833229 4.49238 0.833229 6.33333V7.14726C0.832933 7.16005 0.832935 7.17282 0.833229 7.18556V14.6667C0.833229 16.5076 2.32561 18 4.16656 18H15.8332ZM2.4999 14.6667C2.4999 15.5871 3.24609 16.3333 4.16656 16.3333H15.8332C16.7537 16.3333 17.4999 15.5871 17.4999 14.6667V8.39753L11.2379 10.9023C10.4432 11.2202 9.55663 11.2202 8.76193 10.9023L2.4999 8.39753V14.6667ZM10.6189 9.35488L17.4999 6.60247V6.33333C17.4999 5.41286 16.7537 4.66667 15.8332 4.66667H4.16656C3.24609 4.66667 2.4999 5.41286 2.4999 6.33333V6.60247L9.38091 9.35488C9.77826 9.51382 10.2215 9.51382 10.6189 9.35488Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/messageIcon.a81b31b90328c76c4e492749628a973b.svg";
export { ForwardRef as ReactComponent };